import { contextFromDispatch } from "lib/at-react/ControllerContext";
import { AppState } from "views/authenticated/app/controller/state";
import { initialState } from "views/authenticated/app/controller/initialState";

export const AppControllerContext = contextFromDispatch<AppState>(
  initialState,
  () => {}
);
